import * as ng from 'angular';
import { Title } from './title.directive';


export const TitleModule: string =
    ng.module('title', [
    ])
        .directive('title', Title)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/title/title.module.ts